module.exports = function (hljs) {
  return {
    subLanguage: 'xml',
    contains: [{
      begin: '<%',
      end: '%>',
      subLanguage: 'vbscript'
    }]
  };
};